export default __webpack_public_path__ + "static/qr-58fc1c7c008e4ce7c63d11d32fef175b.png";